<template>
  <div class="container mt20" v-loading="isLoading">
    <div class="relative">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="containers mb10">
        <el-breadcrumb-item :to="{ path: '/apipcEnroll' }">报名通知</el-breadcrumb-item>
        <el-breadcrumb-item><span class="hover">报名详情</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="detail">
      <div class="flex between start nowrap containers mt20 mb80">
        <div class="mr20 BGwhite pad24 radius8 gray1 nowrap initial relative flex1 detail-box">
          <div class="info-top">
            <h1 class="title">{{ detail.Title }}</h1>
            <div class="time flex">
              报名起止日期：
              <div class="flex timebg">
                <div class="home10" />
                <div>{{ detail.EnrollTime }}</div>
              </div>
            </div>
            <div v-if="!checkDateInRange(detail.EnrollTime)" class="pay-btn pay-btn2 disabled-btn">
              报名结束
            </div>
            <template v-else>
              <div v-if="!detail.Price" class="pay-btn pay-btn2" @click="toPay">
                我要报名
              </div>
              <div v-if="!detail.IsPayed && detail.Price" class="pay-btn" @click="toPay">
                我要购买 <span class="Price">¥ {{ detail.Price }}</span>
              </div>
            </template>
          </div>
          <el-table v-if="coursesList.length > 0" :data="coursesList" highlight-current-row @current-change="gotoDetail"
            class="mt40">
            <el-table-column prop="CourseName" label="线上课程名称" min-width="150" />
            <el-table-column prop="ClassifyName" label="课程分类" />
            <el-table-column prop="CourseTypeName" label="" align="center" />
            <el-table-column prop="ChapterNum" label="章节" align="center" />
          </el-table>
          <p v-if="detail.Body" class="my-b-tit mt20 ml20">详情介绍</p>
          <div class="content-container-normal mt10" v-html="detail && detail.Body"></div>
        </div>
        <rightSide class="width340px" v-if="!isLoading" />
      </div>
    </div>
    <el-dialog title="我要报名" :visible.sync="dialogShow" class="width510" @close="close" :append-to-body="true">
      <div class="my-form">
        <div v-for="(item, index) in formList" :key="index" class="mt-form-item">
          <div class="label">
            {{ item.FiledName }}
            <span class="must">({{ item.IsMust ? "必填" : "非必填" }})</span>
            ：
          </div>
          <el-input placeholder="请填写" v-if="item.FiledType == 1" v-model="item.SubContent"></el-input>
          <el-select v-else placeholder="请选择" v-model="item.SubContent">
            <el-option v-for="(it, i) in item.Options" :key="i" :label="it" :value="it" />
          </el-select>
        </div>
        <div class="mt-form-item valiCode">
          <el-input placeholder="验证码" v-model="valiCode"> </el-input>
          <identify ref="identify" :height="46" :width="150" class="identify" />
        </div>
      </div>
      <div slot="footer">
        <el-button class="submit-btn" @click="submit()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  Enroll_GetDetail,
  Enroll_UserSubEnroll,
  Enroll_GetFileds,
} from "@/api/apipcEnroll";
import { CreateOrders } from "@/api/order";
import store from "@/store";

import rightSide from "./child/rightSide.vue";
import { getToken, setToken, removeToken } from "@/util/auth";

import identify from "@/components/identify.vue";
export default {
  name: "apipcEnrollDetail",
  components: {
    rightSide,
    identify,
  },
  data() {
    return {
      tab: 1,
      dialogShow: false,
      formList: [],
      valiCode: "",
      isLogin: getToken() ? true : false,
      isLoading: false,
      detail: null,
      coursesList: [],
    };
  },
  watch: {
    "$route.query.tab"(newValue) {
      if (newValue === undefined) {
        this.$router.go(0);
      }
    },
    "$route.query.SubjectID"(newValue) {
      if (newValue) {
        this.getDetail();
      }
    },

    tab(v) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: v,
        },
      });
    },
  },
  created() {
    const { tab } = this.$route.query;
    if (tab) {
      this.tab = Number(tab);
    }

    this.getDetail();
  },
  methods: {
    gotoDetail(item) {
      this.$router.push({
        path: "/courseDetail",
        query: {
          CourseID: item.CourseID,
        },
      });
    },
    checkDateInRange(EnrollTime) {
      // 验证输入格式
      const rangeRegex =
        /^(\d{4})\.(\d{2})\.(\d{2})\s*-\s*(\d{4})\.(\d{2})\.(\d{2})$/;
      const match = EnrollTime.match(rangeRegex);

      // 解析日期
      const startYear = parseInt(match[1]);
      const startMonth = parseInt(match[2]) - 1;
      const startDay = parseInt(match[3]);

      const endYear = parseInt(match[4]);
      const endMonth = parseInt(match[5]) - 1;
      const endDay = parseInt(match[6]);

      const startDate = new Date(startYear, startMonth, startDay);
      const endDate = new Date(endYear, endMonth, endDay);
      const today = new Date();

      // 重置时间部分为0，只比较日期
      today.setHours(0, 0, 0, 0);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      // 检查当前日期是否在范围内
      if (today >= startDate && today <= endDate) {
        return true;
      } else {
        return false;
      }
    },
    toPay() {
      if (!this.isLogin) {
        store.state.userInfo = {};
        store.state.LoginShow = true;
        localStorage.removeItem("ShareAuthKey");
        return;
      }
      if (this.detail.IsEnrolled) {
        if (!this.detail.IsPayed) {
          this.$router.push({
            path: "/confirmOrder",
            query: {
              OrdersID: this.detail.OrdersID,
            },
          });
        } else {
          this.application();
        }
      } else {
        this.application();
      }
    },
    application() {
      Enroll_GetFileds({
        SubjectID: this.$route.query.SubjectID,
      }).then((res) => {
        this.dialogShow = true;
        this.formList = res.data.map((item) => {
          item.SubContent = "";
          return item;
        });
      });
    },
    submit() {
      if (this.valiCode.trim().length === 0) {
        this.$message.error("图片验证码不能为空");
        return false;
      } else if (this.valiCode !== this.$refs.identify.identifyCode) {
        this.$message.error("图片验证码不正确");
        return false;
      }
      const data = {
        SubjectID: this.$route.query.SubjectID,
        SubItems: this.formList,
      };
      Enroll_UserSubEnroll(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("报名成功");
          this.dialogShow = false;
          this.$refs.identify.drawPic();
          this.getDetail(true);

        } else {
          this.$refs.identify.drawPic();
        }
      });
    },
    booking() {
      this.dialogShow = true;
    },
    close() {
      this.dialogShow = false;
      this.formList = [];
      this.$refs.identify.drawPic();
    },
    getDetail(isAuto = false) {
      this.detail = null;
      this.isLoading = true;

      Enroll_GetDetail({
        SubjectID: this.$route.query.SubjectID,
      })
        .then((res) => {
          this.isLoading = false;
          this.detail = res.data;
          this.coursesList = res.data.Courses;
          if (res.data.Price > 0 && isAuto) {
            this.$router.push({
              path: "/confirmOrder",
              query: {
                OrdersID: res.data.OrdersID,
              },
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.width340px {
  width: 340px;
}

.detail-box {
  max-width: 1400px;

  .info-top {
    text-align: center;

    .title {
      font-size: 30px;
      color: #333333;
    }

    .time {
      margin-top: 20px;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      align-items: center;
      justify-content: center;

      .timebg {
        font-weight: bold;
        color: #1d79ff;
        background: #eff6ff;
        padding: 2px;
        padding-right: 10px;
        border-radius: 4px;

        .home10 {
          width: 25px;
          height: 25px;
          margin-right: 10px;
          background: url("~@/assets/img/home/14.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .pay-btn {
      cursor: pointer;
      width: 290px;
      height: 52px;
      margin: 0 auto;
      margin-top: 50px;
      line-height: 52px;
      display: flex;
      align-items: center;
      gap: 20px;
      justify-content: center;
      background: #1d79ff;
      border-radius: 6px;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;

      .Price {
        font-weight: bold;
        font-size: 24px;
      }
    }

    .disabled-btn {
      cursor: no-drop;
      background-color: #999999;
    }
  }
}

.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}

.my-form {
  .mt-form-item {
    margin-bottom: 20px;

    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
      line-height: 1;
    }

    .must {
      color: #ef3d3d;
    }
  }

  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }

  .valiCode {
    display: flex;

    ::v-deep .el-input__inner {
      width: 340px;
      height: 46px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
    }
  }
}

.identify {
  width: 150px;
  height: 46px;
  overflow: hidden;
  border-radius: 4px;
}

.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}

.my-b-tit {
  font-weight: 600;
}
</style>
